class Drawer extends HTMLElement {
  connectedCallback() {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('[id*=-Overlay]')?.addEventListener('click', this.close.bind(this));
    this.drawerTagName = this.tagName.toLowerCase();
  }

  open(triggeredBy) {

    if (triggeredBy) this.setActiveElement(triggeredBy);

    this.stickProductGridTopBar();

    document.querySelector('drawer.active')?.close();
    document.documentElement.classList.add('drawer--isActive');
    document.documentElement.classList.add(`${this.drawerTagName}--isActive`);
    this.classList.add('active');

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : this.firstElementChild;
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    document.body.classList.add('overflow-hidden');

    this.dispatchEvent(new CustomEvent(`${this.drawerTagName}:toggle`, { detail: { action: 'open' } }));
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    const drawerActiveClasses = document.documentElement.classList.value.split(' ').filter((className) => className.includes('--isActive'));

    if (drawerActiveClasses.length <= 2) {
      document.documentElement.classList.remove('drawer--isActive');
    }
    document.documentElement.classList.remove(`${this.drawerTagName}--isActive`);

    this.unstickProductGridTopBar();

    this.dispatchEvent(new CustomEvent(`${this.drawerTagName}:toggle`, { detail: { action: 'close' } }));
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  stickProductGridTopBar() {
    const productGridTopBar = document.querySelector('.product-grid-top-bar');
    if (!productGridTopBar) return;

    let topBarPosition = productGridTopBar.getBoundingClientRect().top + window.scrollY;
    productGridTopBar.style.top = `${topBarPosition}px`;
    productGridTopBar.style.bottom = `0px`;
  }

  unstickProductGridTopBar() {
    const productGridTopBar = document.querySelector('.product-grid-top-bar');
    if (!productGridTopBar) return;

    productGridTopBar.style.top = '';
    productGridTopBar.style.bottom = '';
  }
  
  getCookie(cookieName) {
    const cookieString = document.cookie;
    const cookies = cookieString.split("; ");
    const cookie = cookies.find(row => row.startsWith(`${cookieName}=`));
    const result = cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
    return result;
  }
}

class DrawerButton extends Drawer {
  drawerTag = null;
  drawer = null;

  connectedCallback() {

    this.drawerTag = this.dataset.drawerTag;
    if (!this.drawerTag) {
      return;
    }

    this.addEventListener('click', () => {
      if (!this.drawer) {
        this.drawer = document.querySelector(this.drawerTag);
        if (!this.drawer) return;

        this.addDrawerListener();
      }
        
      this.handleClick();
  } );
  }

  addDrawerListener() {
    this.drawer.addEventListener(`${this.drawerTag}:toggle`, (evt) => {
      if (evt.detail.action === 'open') {
        this.dataset.action = true;
      } else {
        this.dataset.action = '';
      }
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', () => {
      this.handleClick();
    });

    this.drawer?.removeEventListener(`${this.drawerTag}:toggle`, (evt) => {
      if (evt.detail.action === 'open') {
        this.dataset.action = true;
      } else {
        this.dataset.action = '';
      }
    });
  }

  toggleDrawer() {
    let action = (this.dataset.action) ? this.dataset.action : 'open';
    if (action === 'open') {
      this.drawer.open();
    } else {
      this.drawer.close();
    }
  }

  handleClick() {
    this.toggleDrawer();
  }
}

class FacetsDrawer extends Drawer {
  open(triggeredBy) {

    if (triggeredBy) this.setActiveElement(triggeredBy);

    // this.stickProductGridTopBar();

    document.querySelector('drawer.active')?.close();
    document.documentElement.classList.add('drawer--isActive');
    document.documentElement.classList.add(`${this.drawerTagName}--isActive`);
    this.classList.add('active');

    this.dispatchEvent(new CustomEvent(`${this.drawerTagName}:toggle`, { detail: { action: 'open' } }));
  }

  close() {
    this.classList.remove('active');

    document.documentElement.classList.remove('drawer--isActive');
    document.documentElement.classList.remove(`${this.drawerTagName}--isActive`);

    this.unstickProductGridTopBar();

    this.dispatchEvent(new CustomEvent(`${this.drawerTagName}:toggle`, { detail: { action: 'close' } }));
  }
}
class FacetsSideDrawer extends Drawer {
  open(triggeredBy) {

    if (triggeredBy) this.setActiveElement(triggeredBy);

    document.querySelector('drawer.active')?.close();
    document.body.classList.add('facets-side-drawer--isActive');
    this.classList.add('active');

    this.dispatchEvent(new CustomEvent(`${this.drawerTagName}:toggle`, { detail: { action: 'open' } }));
  }

  close() {
    this.classList.remove('active');

    document.body.classList.remove('facets-side-drawer--isActive');
    this.dispatchEvent(new CustomEvent(`${this.drawerTagName}:toggle`, { detail: { action: 'close' } }));
  }
}

class FacetsSearchDrawer extends FacetsDrawer {
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.stickProductGridTopBar();
    document.querySelector('drawer.active')?.close();
    document.documentElement.classList.add('drawer--isActive');
    document.documentElement.classList.add(`${this.drawerTagName}--isActive`);
    this.classList.add('active');
    this.dispatchEvent(new CustomEvent(`${this.drawerTagName}:toggle`, { detail: { action: 'open' } }));
  }

  close() {
    this.classList.remove('active');

    document.documentElement.classList.remove('drawer--isActive');
    document.documentElement.classList.remove(`${this.drawerTagName}--isActive`);

    this.unstickProductGridTopBar();

    this.dispatchEvent(new CustomEvent(`${this.drawerTagName}:toggle`, { detail: { action: 'close' } }));
  }
}
class FacetsSearchSideDrawer extends FacetsSideDrawer {
}

class FacetsDrawerButton extends DrawerButton {
  lsKey = 'idhl_pcp_facets-drawer';

  handleClick() {
    let action = (this.dataset.action) ? this.dataset.action : 'open';
    const isHeaderSearchOpen = document.querySelector('header-search--open') ? true : false;
    if (action === 'open') {
      this.drawer.open();
      if (!isHeaderSearchOpen) {
        this.setLocalStorageItem(true)
      }
    } else {
      this.drawer.close();
      if (!isHeaderSearchOpen) {
        this.setLocalStorageItem(false);
      }
    }
  }

  getLocalStorageItem() {
    let object = JSON.parse(localStorage.getItem(this.lsKey));

    if (object) {
      return object;
    }
  }

  createLocalStorageObject(isOpen) {
    let object = {
      isOpen: isOpen
    };

    return JSON.stringify(object);
  }

  setLocalStorageItem(isOpen) {
    localStorage.setItem(this.lsKey, this.createLocalStorageObject(isOpen));
  }
}

class LanguageDrawer extends Drawer {
}
class LanguageDrawerButton extends DrawerButton {
}

class CurrencyDrawer extends Drawer {
  close() {
    const cookieName = "shippingShown";
    const cookieNameLocal = "localePopup";

    // Check if the cookies match the required values
    if (this.getCookie(cookieName) === "shippingShown" || this.getCookie(cookieNameLocal) === "shown") {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');

      // Remove active drawer classes
      const drawerActiveClasses = document.documentElement.classList.value.split(' ').filter((className) => className.includes('--isActive'));

      if (drawerActiveClasses.length <= 2) {
        document.documentElement.classList.remove('drawer--isActive');
      }
      document.documentElement.classList.remove(`${this.drawerTagName}--isActive`);

      // Unstick the product grid top bar (if applicable)
      this.unstickProductGridTopBar();

      // Dispatch the custom close event
      this.dispatchEvent(new CustomEvent(`${this.drawerTagName}:toggle`, { detail: { action: 'close' } }));
    }
  }
}

class CurrencyDrawerButton extends DrawerButton {
}

class ChristmasCalendarDrawer extends Drawer {
}
class ChristmasCalendarDrawerButton extends DrawerButton {
  handleClick() {
    let action = (this.dataset.action) ? this.dataset.action : 'open';

    let christmasCalendarFooterElement = document.querySelector('[data-christmas-calendar-footer]');

    if (!this.classList.contains('is-date-eligible') && christmasCalendarFooterElement) {
      return christmasCalendarFooterElement.scrollIntoView({ behavior: 'smooth' });
    }

    if (action === 'open') { 
      this.drawer.open();
    } else {
      this.drawer.close();
    }

    window.dispatchEvent(new CustomEvent('christmas-calendar-drawer-button:click', {
      detail: {
        headingHtml: this.getAttribute('data-drawer-heading-html'),
        contentHtml: this.getAttribute('data-drawer-content-html')
      }
    }));
  }
}

customElements.define('drawer-button', DrawerButton);

customElements.define('facets-drawer', FacetsDrawer);
customElements.define('facets-side-drawer', FacetsSideDrawer);
customElements.define('facets-search-drawer', FacetsSearchDrawer);
customElements.define('facets-search-side-drawer', FacetsSearchSideDrawer);
customElements.define('facets-drawer-button', FacetsDrawerButton);

customElements.define('language-drawer', LanguageDrawer);
customElements.define('language-drawer-button', LanguageDrawerButton);

customElements.define('currency-drawer', CurrencyDrawer);
customElements.define('currency-drawer-button', CurrencyDrawerButton);

customElements.define('christmas-calendar-drawer', ChristmasCalendarDrawer);
customElements.define('christmas-calendar-drawer-button', ChristmasCalendarDrawerButton);
